// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._40bH2{display:inline-block;padding:6px 8px 7px 8px;font-size:12px}", "",{"version":3,"sources":["webpack://./src/desktop/components/RiddlesAdmin/AddRiddleForm/addriddleform.scss"],"names":[],"mappings":"AAAA,QACE,oBAAA,CACA,uBAAA,CACA,cAAA","sourcesContent":[".panelButton {\n  display: inline-block;\n  padding: 6px 8px 7px 8px;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelButton": "_40bH2"
};
export default ___CSS_LOADER_EXPORT___;
